import React, {Component} from 'react';
import {Modal, Tree, Checkbox, Button, Icon, Spin} from 'antd';
import PropTypes from 'prop-types';
import _ from 'underscore';
import command from "../routes/notice/command";
import {app} from "../app";

const TreeNode = Tree.TreeNode;

/**
 * 检查是否存在，不存在则添加
 * @param arr
 * @param val
 * @returns {*}
 */
function checkExist(arr, val) {
    if (arr.indexOf(val) === -1) {
        arr.push(val);
    }
    return arr;
}

class SelectPlayers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible || false,
            senObj: props.rights,
            rights: props.rights,
            provinceList: [],
            proSelList: [],
            teamList: [],
            teamSelList: [],
            playerChecks: [],
            playerList: [],
            selResult: {
                province: "",
                team: "",
                user: "",
            },
        };
    }

    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(props) {
        let {visible} = props;
        if (visible && !this.state.visible) {
            this.openModal();
        }
    }

    /**
     * 打开对话框
     */
    openModal = async () => {
        await this.setData({modal_loading: true});
        let {rights} = this.state;
        if (rights === 1) {
            let provinceList = await this.provinceData();
            await this.setData({provinceList});
        } else if (rights === 2) {
            let teamList = await this.teamData();
            await this.setData({teamList});
        } else if (rights === 3) {
            let playerList = await this.playerData();
            await this.setData({playerList});
        }
        await this.setData({visible: true, modal_loading: false});
    }

    /**
     * 关闭对话框
     */
    closeModal = async () => {
        let {rights} = this.state;
        await this.setData({
            visible: false,
            send_loading: false,
            provinceList: [],
            proSelList: [],
            teamList: [],
            teamSelList: [],
            playerList: [],
            playerChecks: [],
            senObj: rights,
            selResult: {
                province: "",
                team: "",
                user: "",
            },
        });
    }

    /**
     * 省份数据
     */
    provinceData = async () => {
        let {provinceApi} = this.props,
            params = {
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
        let {flag, data, msg} = await app.post(provinceApi, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        return data;
    }

    /**
     * 队伍数据
     */
    teamData = async (province = "") => {
        let {teamApi} = this.props,
            params = {
                province,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
        let {flag, data, msg} = await app.post(teamApi, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        return data;
    }

    /**
     * 队员数据
     */
    playerData = async (teamno = "") => {
        let {playerApi} = this.props,
            params = {
                teamno,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
        let {flag, data, msg} = await app.post(playerApi, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        return data;
    }

    /**
     * 发布对象上一步
     */
    handleObjPrev = async () => {
        let {senObj} = this.state;
        if (senObj > 0) {
            switch (senObj) {
                case 1:
                    await this.setData({proSelList: []});
                    break;
                case 2:
                    await this.setData({teamSelList: []});
                    break;
                case 3:
                    await this.setData({playerChecks: []});
                    break;
            }
            senObj -= 1;
            this.setData({senObj});
        }
    }

    /**
     * 发布对象下一步
     */
    handleObjNext = async () => {
        if (this.state.modal_loading) return;
        let {senObj} = this.state,
            afterState = {modal_loading: false};
        senObj++;
        await this.setData({senObj, modal_loading: true});
        switch (senObj) {
            case 2:
                let {proSelList} = this.state;
                proSelList = proSelList.join(',');
                if (!proSelList) {
                    app.alert("请选择省份！", "warn");
                    return false;
                }
                let teamList = await this.teamData(proSelList);
                afterState.teamList = teamList;
                break;
            case 3:
                let {teamSelList} = this.state, list1 = [];
                teamSelList.forEach((team) => {
                    list1 = list1.concat(team.list);
                });
                list1 = list1.join(',');
                if (!list1) {
                    app.alert("请选择队伍！", "warn");
                    return false;
                }
                let playerList = await this.playerData(list1);
                afterState.playerList = playerList;
                afterState.selResult = {
                    province: "",
                    team: "",
                    user: "",
                };
                break;
        }
        await this.setData(afterState);
    }

    /**
     * 全部选择
     **/
    handleAllSel = async (e, type) => {
        let {checked} = e.target,
            afterState = {};
        switch (type) {
            case 0: //职能全选
                let {classList, classSelList} = this.state;
                if (checked) {
                    classSelList = classList.map((cla) => {
                        return cla.id;
                    });
                } else {
                    classSelList = [];
                }
                afterState.classSelList = classSelList;
                break;
            case 1: //省份全选
                let {provinceList, proSelList} = this.state;
                if (checked) {
                    proSelList = provinceList.map((pro) => {
                        return pro.area_name;
                    });
                } else {
                    proSelList = [];
                }
                afterState.proSelList = proSelList;
                break;
            case 2: //队伍全选
                let {teamList, teamSelList} = this.state;
                if (checked) {
                    teamSelList = Object.keys(teamList).map((team) => {
                        return {
                            id: team,
                            list: teamList[team].map((t) => {
                                return t.teamno;
                            })
                        }
                    })
                } else {
                    teamSelList = [];
                }
                afterState.teamSelList = teamSelList;
                break;
        }
        await this.setData(afterState);
    }

    /**
     * 树形全选
     * @param e
     * @param type
     */
    handleSel2 = async (e, type) => {
        let province = [], team = [], user = [];
        switch (type) {
            case 1:
                break;
            case 2:
                break;
            case 3:
                e.forEach((c) => {
                    let arr = c.split('-ltjy-');
                    if (arr.length === 3) {
                        province.push(arr[0]);
                        team.push(arr[1]);
                        user.push(arr[2]);
                    }
                });
                let selResult1 = {
                    province: _.uniq(province).join(','),
                    team: _.uniq(team).join(','),
                    user: user.join(','),
                };
                await this.setData({playerChecks: e, selResult: selResult1});
                break;
        }
    }

    /**
     * 选择单个
     * @param e
     * @param type
     * @param id
     */
    handleSel = async (e, type, id) => {
        let {checked} = e.target,
            {teamSelList} = this.state,
            afterState = {};
        switch (type) {
            case 0: //职能选择
                let {classSelList} = this.state;
                if (checked) {
                    classSelList.push(id);
                } else {
                    classSelList.splice(classSelList.indexOf(id), 1);
                }
                afterState.classSelList = classSelList;
                break;
            case 1: //省份选择
                let {proSelList} = this.state;
                if (checked) {
                    proSelList.push(id);
                } else {
                    proSelList.splice(proSelList.indexOf(id), 1);
                }
                afterState.proSelList = proSelList;
                break;
            case 2: //队伍省份选择
                let {teamList} = this.state;
                if (checked) {
                    const tIndex = teamSelList.findIndex(v => v.id === id);
                    if (tIndex >= 0) {
                        teamSelList[tIndex].list = teamList[id].map((t) => {
                            return t.teamno;
                        });
                    } else {
                        teamSelList.push({
                            id,
                            list: teamList[id].map((t) => {
                                return t.teamno;
                            })
                        });
                    }
                } else {
                    teamSelList.splice(teamSelList.findIndex(value => value.id === id), 1);
                }
                afterState.teamSelList = teamSelList;
                break;
            case 3://队伍选择
                let val = id.split('-');
                const v1 = teamSelList.findIndex(val1 => val1.id === val[0]);
                if (checked) {
                    if (v1 >= 0) {
                        teamSelList[v1].list.push(val[1]);
                    } else {
                        teamSelList.push({
                            id: val[0],
                            list: [val[1]]
                        });
                    }
                } else {
                    teamSelList[v1].list.splice(teamSelList[v1].list.indexOf(val[1]), 1);
                }
                afterState.teamSelList = teamSelList;
                break;
        }
        await this.setData(afterState);
    }

    /**
     * 按身份选择
     * @param e
     * @param type
     */
    handlePlayerSFSel = async (e, type) => {
        let sf = "";
        let {playerList, playerChecks, selResult} = this.state;
        let province = selResult.province ? selResult.province.split(',') : [],
            team = selResult.team ? selResult.team.split(',') : [],
            user = selResult.user ? selResult.user.split(',') : [],
            {checked} = e.target;
        switch (type) {
            case 1://队长
                sf = "teamheader";
                break;
            case 2://管理员
                sf = "administrator";
                break;
            case 3://队员
                sf = "RZ";
                break;
            case 4://预备队员
                sf = "NORZ";
                break;
            case 5://志愿者
                sf = "ZYZ";
                break;
        }
        for (let t_k in playerList) {
            //队伍
            const pInfo = playerList[t_k], ai = playerChecks.indexOf('0'), tki = playerChecks.indexOf(t_k);
            //判断不选择下去掉全选
            if (checked) {
                province = checkExist(province, pInfo.province);
                team = checkExist(team, pInfo.teamno);
            } else {
                if (ai >= 0) {
                    playerChecks.splice(ai, 1);
                }
                if (tki >= 0) {
                    playerChecks.splice(tki, 1);
                }
                let pi = province.indexOf(pInfo.province), ti = team.indexOf(pInfo.teamno);
                if (pi >= 0) {
                    province.splice(pi, 1);
                }
                if (ti >= 0) {
                    team.splice(ti, 1);
                }
            }
            for (let s_k in pInfo) {
                if (s_k === sf) {
                    const sfInfo = pInfo[s_k];
                    let val1 = `${t_k}-ltjy-${s_k}`, vi1 = playerChecks.indexOf(val1);
                    if (vi1 === -1) {
                        if (sfInfo.length > 0) playerChecks.push(val1);
                    } else {
                        if (!checked) {
                            playerChecks.splice([vi1], 1);
                        }
                    }
                    for (let p_key in sfInfo) {
                        let indexno = sfInfo[p_key].indexno,
                            val2 = `${pInfo.province}-ltjy-${pInfo.teamno}-ltjy-${indexno}`,
                            vi2 = playerChecks.indexOf(val2), vi3 = user.indexOf(indexno);
                        if (checked) {
                            if (vi2 === -1) {
                                playerChecks.push(val2);
                                user.push(indexno);
                            }
                        } else {
                            if (vi2 >= 0) {
                                playerChecks.splice([vi2], 1);
                            }
                            if (vi3 >= 0) {
                                user.splice(vi3, 1);
                            }
                        }
                    }
                }
            }
        }
        selResult = {
            province: _.uniq(province).join(','),
            team: _.uniq(team).join(','),
            user: user.join(','),
        };
        await this.setData({playerChecks, selResult});
    }

    /**
     * 成功
     * @returns {Promise<void>}
     */
    handleSuccess = async () => {
        let {selResult, send_loading} = this.state;
        if (send_loading) return;
        if (!selResult.user) {
            app.alert("请选择队员");
            return;
        }
        await this.setData({send_loading: true});
        let flag = await this.props.success(selResult);
        if (flag) {
            await this.closeModal();
        } else {
            await this.setData({send_loading: false});
        }
    }

    render() {
        let {
                visible, rights, modal_loading, senObj, send_loading, proSelList, provinceList,
                teamSelList, teamList, selResult, playerChecks, playerList
            } = this.state,
            prev_visable = senObj > rights,
            next_visable = senObj < 3,
            teamAll = false,
            obj_text = "选择省份",
            obj_node = null;
        if (teamSelList.length !== 0 && Object.keys(teamList).length === teamSelList.length) {
            teamAll = true;
            for (let t in teamList) {
                let i10 = teamSelList.findIndex(v => v.id === t);
                if (!i10 && i10 !== 0) {
                    teamAll = false;
                    break;
                }
                teamAll = teamSelList[i10].list.length === teamList[t].length;
                if (!teamAll) break;
            }
        }
        switch (senObj) {
            case 1:
                obj_text = "选择省份";
                obj_node = (
                    <div className="provices sel-item">
                        <div className="content">
                            <div className="all-sel">
                                <Checkbox onChange={(e) => this.handleAllSel(e, 1)}
                                          checked={proSelList.length !== 0 && proSelList.length === provinceList.length}>全国</Checkbox>
                            </div>
                            <div className="list">
                                {
                                    provinceList.map((pro, i) => {
                                        return (
                                            <Checkbox key={i}
                                                      checked={proSelList.indexOf(pro.area_name) > -1}
                                                      onChange={(e) => this.handleSel(e, 1, pro.area_name)}>{pro.area_name}</Checkbox>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                );
                break;
            case 2:
                obj_text = "选择队伍";
                obj_node = (
                    <div className="teams sel-item">
                        <div className="content">
                            <div className="all-sel">
                                <Checkbox onChange={(e) => this.handleAllSel(e, 2)}
                                          checked={teamAll}>所有队伍</Checkbox>
                            </div>
                            <div className="list">
                                {
                                    Object.keys(teamList).map((team, i) => {
                                        return (
                                            <div className="l-item" key={i}>
                                                <div className="li-title">
                                                    <Checkbox
                                                        checked={teamSelList.findIndex(val => val.id === team) >= 0 && teamSelList[teamSelList.findIndex(val => val.id === team)].list.length === teamList[team].length}
                                                        onChange={(e) => this.handleSel(e, 2, team)}>{team}</Checkbox>
                                                </div>
                                                <div className="li-content">
                                                    {
                                                        teamList[team].map((t1, i2) => {
                                                            return (
                                                                <Checkbox key={i2}
                                                                          checked={teamSelList.findIndex(val => val.id === team) >= 0 ? teamSelList[teamSelList.findIndex(val => val.id === team)].list.indexOf(t1.teamno) >= 0 : false}
                                                                          onChange={(e) => this.handleSel(e, 3, `${team}-${t1.teamno}`)}>{t1.teamname}</Checkbox>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                );
                break;
            case 3:
                obj_text = "选择人员";
                obj_node = (
                    <div className="players sel-item">
                        <div className="title">
                            <div
                                className="total-people">共选人数：{(selResult.user ? selResult.user.split(',') : []).length} 人
                            </div>
                            <div className="checks">
                                <Checkbox
                                    onChange={(e) => this.handlePlayerSFSel(e, 1)}>队长</Checkbox>
                                <Checkbox
                                    onChange={(e) => this.handlePlayerSFSel(e, 2)}>管理员</Checkbox>
                                <Checkbox
                                    onChange={(e) => this.handlePlayerSFSel(e, 3)}>队员</Checkbox>
                                <Checkbox
                                    onChange={(e) => this.handlePlayerSFSel(e, 4)}>预备队员</Checkbox>
                                <Checkbox
                                    onChange={(e) => this.handlePlayerSFSel(e, 5)}>志愿者</Checkbox>
                            </div>
                        </div>
                        <div className="content">
                            <Tree
                                checkable
                                showIcon={true}
                                onCheck={(e) => this.handleSel2(e, 3)}
                                checkedKeys={playerChecks}
                            >
                                <TreeNode title="所有队员" key="0">
                                    {
                                        Object.keys(playerList).map((player) => {
                                            let pInfo = playerList[player];
                                            return (
                                                <TreeNode title={player} key={player}>
                                                    {
                                                        Object.keys(pInfo).map((sf) => {
                                                            let sfInfo = pInfo[sf];
                                                            return sfInfo.length > 0 && sf !== "teamno" && sf !== "province" ? (
                                                                <TreeNode
                                                                    title={command.checkSF(sf)}
                                                                    key={`${player}-ltjy-${sf}`}>
                                                                    {sfInfo.map((p1) => {
                                                                        return (
                                                                            <TreeNode
                                                                                title={p1.vname}
                                                                                key={`${pInfo.province}-ltjy-${pInfo.teamno}-ltjy-${p1.indexno}`}
                                                                            />
                                                                        )
                                                                    })}
                                                                </TreeNode>
                                                            ) : null
                                                        })
                                                    }
                                                </TreeNode>
                                            )
                                        })
                                    }
                                </TreeNode>
                            </Tree>
                        </div>
                    </div>
                );
                break;
        }
        return (
            <Modal
                visible={visible}
                onCancel={this.closeModal}
                footer={
                    <div className="footer-text">
                        <Icon type="info-circle" style={{fontSize: 14, marginRight: 10}}/>
                        由于数据量较大，可能导致加载速度较慢，请您耐心等候~
                    </div>
                }
                title={<div style={{textAlign: "center"}}>{obj_text}</div>}
                maskClosable={false}
                destroyOnClose={true}
                keyboard={false}
                className="notice-release-send-modal"
                width={1000}
                style={{top: "10%"}}
            >
                {modal_loading ? (<div className="modal-loading"><Spin/></div>) : obj_node}
                <div className="btns">
                    {prev_visable ? (
                        <Button onClick={() => this.handleObjPrev()}>上一步</Button>) : null}
                    {next_visable ? (
                        <Button onClick={() => this.handleObjNext()}>下一步</Button>) : null}
                    {senObj === 3 ? (
                        <Button onClick={() => this.handleSuccess()} loading={send_loading}>完成</Button>) : null}
                    <Button onClick={() => this.closeModal()}>取消</Button>
                </div>
            </Modal>
        );
    }
}

SelectPlayers.propTypes = {
    rights: PropTypes.number.isRequired,
    success: PropTypes.func.isRequired,
    provinceApi: PropTypes.string.isRequired,
    teamApi: PropTypes.string.isRequired,
    playerApi: PropTypes.string.isRequired,
    visible: PropTypes.any,
};

export default SelectPlayers;



// WEBPACK FOOTER //
// ./src/components/SelectPlayers.jsx